<div [ngClass]="{'calc-width po-component-container': !isSmallScreen()}">
  <!--  <div class="d-flex justify-content-end me-4 pt-2 mb-2" *ngIf="isSmallScreen()" matTooltip="Select Order Type">-->
  <!--    &lt;!&ndash; <button *ngIf="isSmallScreen()" nz-button nzType="primary" class="btn-radius me-3" (click)="OnSelectOrderType()">Order Type</button> &ndash;&gt;-->
  <!--    <em class="las la-utensils " style="font-size: 28px; color: #000000" (click)="OnSelectOrderType()"></em>-->
<!--  </div>-->
<div class="row g-0">
  <div class="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-10">
    <div scrollSpy [offset]="50" [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)"
      class="scrollItems">
      <div class="section-bg header01" id="header01" style="z-index: 1000;">
        <div class="d-flex justify-content-between align-items-center">
          <div class="section-chips">
            @for (section of sectionTable; track section) {
              <div class="menu-box"
                (click)="scrollTo(section.id)" [ngClass]="{'table-selected': currentSection === section.id}">
                <p class="mb-0 text-center">{{ section.name }}</p>
              </div>
            }
          </div>
          <div class="d-flex justify-content-end d-md-none" matTooltip="Select Order Type">
            <!-- <button *ngIf="isSmallScreen()" nz-button nzType="primary" class="btn-radius me-3" (click)="OnSelectOrderType()">Order Type</button> -->
            <em class="las la-utensils " style="font-size: 28px; color: #000000" (click)="OnSelectOrderType()"></em>
          </div>
        </div>
      </div>
      @for (section of sectionTable; track section) {
        <section [id]="section.id">
          <div class="header text-center">{{ section.name }}</div>
          <!--          <div class="container">-->
          <div class="tables-grid">
            @for (table of section.tableResponses; track table) {
              <div
                class="cursor box"
                [ngClass]="{'selected': selectedTables.has(table)}"
                (click)="onTableSelectionChange(table, section.id, section.name)">
                <div class="text-center">
                  <div
                  [ngClass]="{
    'free-pill': table.canTakeMultipleOrders && table.availabilityStatus !== 1 || table.availabilityStatus === 1,
    'occupied-pill': !(table.canTakeMultipleOrders && table.availabilityStatus !== 1 || table.availabilityStatus === 1)
  }">
                    @if (table.canTakeMultipleOrders) {
                      <p class="mb-0">Free</p>
                    } @else {
                      <p class="mb-0">{{ table.availabilityStatus === 1 ? 'Free' : 'In-Use' }}</p>
                    }
                  </div>
                  <div class="table-name">
                    <p class="mb-0 fs-6 text-weight">{{ table.name }}</p>
                  </div>
                  <div class="seating-pill d-flex">
                    <span class="my-auto">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M13 8.5H11V6.5H12C12.2652 6.5 12.5196 6.39464 12.7071 6.20711C12.8946 6.01957 13 5.76522 13 5.5V2.5C13 2.23478 12.8946 1.98043 12.7071 1.79289C12.5196 1.60536 12.2652 1.5 12 1.5H4C3.73478 1.5 3.48043 1.60536 3.29289 1.79289C3.10536 1.98043 3 2.23478 3 2.5V5.5C3 5.76522 3.10536 6.01957 3.29289 6.20711C3.48043 6.39464 3.73478 6.5 4 6.5H5V8.5H3C2.73478 8.5 2.48043 8.60536 2.29289 8.79289C2.10536 8.98043 2 9.23478 2 9.5V10.5C2 10.7652 2.10536 11.0196 2.29289 11.2071C2.48043 11.3946 2.73478 11.5 3 11.5H3.5V14C3.5 14.1326 3.55268 14.2598 3.64645 14.3536C3.74021 14.4473 3.86739 14.5 4 14.5C4.13261 14.5 4.25979 14.4473 4.35355 14.3536C4.44732 14.2598 4.5 14.1326 4.5 14V11.5H11.5V14C11.5 14.1326 11.5527 14.2598 11.6464 14.3536C11.7402 14.4473 11.8674 14.5 12 14.5C12.1326 14.5 12.2598 14.4473 12.3536 14.3536C12.4473 14.2598 12.5 14.1326 12.5 14V11.5H13C13.2652 11.5 13.5196 11.3946 13.7071 11.2071C13.8946 11.0196 14 10.7652 14 10.5V9.5C14 9.23478 13.8946 8.98043 13.7071 8.79289C13.5196 8.60536 13.2652 8.5 13 8.5ZM10 8.5H6V6.5H10V8.5Z"
                          fill="currentColor"/>
                      </svg>
                    </span>
                    <p class="mb-0 ms-1">{{ table.seatingCapacity }}</p>
                  </div>
                </div>
              </div>
            }
          <!--            </div>-->
        </div>
      </section>
    }
  </div>
  <div class="d-md-none order-btn-fixed cursor text-center" (click)="OnSelectedTables()">Create Order</div>
</div>
<div class="d-none d-sm-none d-md-flex col-md-4 col-lg-3 col-xl-2 user-details d-flex flex-column">
  <p class="text-weight fs-6 my-2">Order Type</p>
  <div class="row gx-2 gy-2">
    @for (orderTypeVal of orderTypeKeyValue; track orderTypeVal.key) {
      <div class="col-6 d-flex justify-content-center">
        <div [class.selectedO]="orderTypeVal.key === orderType"
          class="order-type cursor text-center p-3 w-100" (click)="selectOrderType(orderTypeVal.key)">
          <p class="mb-0">{{ orderTypeVal.value }}</p>
        </div>
      </div>
    }
  </div>
  <div class="mt-5">
    <p class="text-weight fs-6">Customer Name</p>
    <nz-form-control>
      <input nz-input [(ngModel)]="customerName" nzSize="large" placeHolder="Enter customer name">
    </nz-form-control>
  </div>
  <div class="mt-5">
    <p class="text-weight fs-6">Customer Phone</p>
    <nz-form-control>
      <input nz-input [(ngModel)]="customerPhone" nzSize="large" placeHolder="Enter customer phone"/>
    </nz-form-control>
  </div>
  <div class="order-btn cursor text-center mt-auto" (click)="OnSelectedTables()">Create Order</div>
</div>
</div>


</div>

